import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgZoomOut = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m32.819 28.578 9.365 9.364-4.243 4.242-9.365-9.364a14.56 14.56 0 0 1-8.003 2.39c-8.083 0-14.636-6.553-14.636-14.636 0-8.084 6.554-14.636 14.637-14.636S35.21 12.491 35.21 20.574a14.56 14.56 0 0 1-2.391 8.004M20.573 8.938c-6.416 0-11.636 5.219-11.636 11.636s5.22 11.636 11.636 11.636 11.636-5.22 11.636-11.636-5.22-11.636-11.636-11.636m7.931 13.135v-3h-15.86v3z" })
});
export default SvgZoomOut;
